var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "./EventEmitter"], function (require, exports, EventEmitter_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var FileUpload = (function (_super) {
        __extends(FileUpload, _super);
        function FileUpload(name, file) {
            var _this = _super.call(this) || this;
            _this.name = "";
            _this.progress = 0;
            _this.url = "";
            _this.name = name;
            _this.file = file;
            _this.url = "";
            _this.progress = 0;
            _this.host = null;
            _this.mediaId = "";
            return _this;
        }
        Object.defineProperty(FileUpload.prototype, "Name", {
            get: function () {
                return this.name;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FileUpload.prototype, "Progress", {
            get: function () {
                return this.progress;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FileUpload.prototype, "ResponseObject", {
            get: function () {
                return this.responseObject;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FileUpload.prototype, "Url", {
            get: function () {
                return this.url;
            },
            enumerable: true,
            configurable: true
        });
        FileUpload.prototype.SetUrl = function (url) {
            this.url = url;
        };
        FileUpload.prototype.SetProgress = function (progress) {
            this.progress = progress;
        };
        FileUpload.prototype.SetResponseObject = function (responseObject) {
            this.responseObject = responseObject;
        };
        return FileUpload;
    }(EventEmitter_1.EventEmitter));
    exports.FileUpload = FileUpload;
    var MinioClient = (function (_super) {
        __extends(MinioClient, _super);
        function MinioClient(presignedUrlCtrl) {
            var _this = _super.call(this) || this;
            _this.debug = false;
            _this.fileUploadArray = {};
            _this.presignedUrlCtrl = presignedUrlCtrl;
            return _this;
        }
        MinioClient.prototype.GetFileUploads = function () {
            return this.fileUploadArray;
        };
        MinioClient.prototype.UploadFiles = function (fileUploadArray) {
            this.fileUploadArray = fileUploadArray;
            for (var fileUpload in fileUploadArray) {
                this.RetrieveNewURL(fileUploadArray[fileUpload]);
            }
        };
        MinioClient.prototype.RetrieveNewURL = function (fileUpload) {
            if (this.debug)
                console.log("MinioClient - RetrieveNewURL: " + fileUpload.Name);
            fileUpload.host = this;
            var request = $.ajax(this.presignedUrlCtrl, {
                data: JSON.stringify(fileUpload.requestObject),
                contentType: 'application/json',
                type: 'POST',
                cache: false,
                async: true
            });
            request.done(this.OnPresignedUrlReceived.bind(this));
            request.fail(this.OnPresignedUrlFailed.bind(this));
        };
        MinioClient.prototype.OnPresignedUrlReceived = function (data) {
            if (this.debug)
                console.log("MinioClient - OnPresignedUrlReceived: " + data.url);
            var fileName = data.fileName;
            var fileUpload = this.fileUploadArray[fileName];
            fileUpload.SetUrl(data.url);
            fileUpload.mediaId = data.mediaId;
            fileUpload.SetResponseObject(data.Asset);
            if (this.debug)
                if (fileUpload == null) {
                    console.error("MinioClient - fileUpload = undefined. No FileUpload object found with name: " + fileName);
                    return;
                }
            this.FireEvent("GetPresignedUrlFinished", data);
            this.UploadFile(fileUpload);
        };
        MinioClient.prototype.OnPresignedUrlFailed = function (jqXHR, textStatus) {
            if (this.debug)
                console.error("MinioClient - OnPresignedUrlFailed: " + textStatus + " " + jqXHR);
            this.FireEvent("GetPresignedUrlFailed", { error: textStatus });
        };
        MinioClient.prototype.UploadFile = function (fileUpload) {
            if (this.debug)
                console.log("MinioClient - UploadFile: " + fileUpload.Name);
            $.ajax({
                type: "PUT",
                url: fileUpload.Url,
                xhr: function () {
                    var xhr = $.ajaxSettings.xhr();
                    xhr.upload.addEventListener("progress", function (evt) {
                        if (evt.lengthComputable) {
                            var percentComplete = evt.loaded / evt.total;
                            console.log(percentComplete);
                            fileUpload.SetProgress(percentComplete);
                            fileUpload.FireEvent("FileProgress", { progress: percentComplete });
                        }
                    }, false);
                    return xhr;
                },
                success: function () {
                    if (this.debug)
                        console.log("MinioClient - File Uploaded");
                    fileUpload.host.FireEvent("FileUploaded", { fileUpload: fileUpload });
                },
                error: function (data) {
                    if (this.debug) {
                        console.log("MinioClient - File Upload Failed");
                    }
                    fileUpload.host.FireEvent("FileUploadFailed", { error: data, fileUpload: fileUpload });
                },
                async: true,
                data: fileUpload.file,
                cache: false,
                contentType: false,
                processData: false,
                timeout: 0
            });
        };
        return MinioClient;
    }(EventEmitter_1.EventEmitter));
    exports.MinioClient = MinioClient;
});
//# sourceMappingURL=MinioClient.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/MinioClient.js
// module id = 154
// module chunks = 0